import React, { useEffect, useState } from 'react'
import ClientCompanyModel from './models/ClientCompanyModel';

function ViewClientCompany(props) {
  const [clientCompanyData, setclientCompanyData] = useState(new ClientCompanyModel());

  useEffect(() => {
    setclientCompanyData(props.ClientCompanyData);
  }, [props.ClientCompanyData])
  return (
    <>
      
      <div className="row">
        <div className="mb-3">
          <label className="form-label"> Client Company Type</label>
          <input type="text" className="form-control" value={clientCompanyData.ClientCompanyTypeName} disabled />
        </div>
        <div className="mb-3">
          <label className="form-label"> Client Company Name</label>
          <input type="text" className="form-control" value={clientCompanyData.ClientCompanyName} disabled />
        </div>  
        <div className="col-md-6 mb-3">
          <label className="form-label">RMO 1 Name</label>
          <input type="text" className="form-control" value={clientCompanyData.RMName1} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Contact</label>
          <input type="text" className="form-control" value={clientCompanyData.RMContact1} disabled />
        </div>
         <div className="col-md-6 mb-3">
          <label className="form-label">RMO 2 Name</label>
          <input type="text" className="form-control" value={clientCompanyData.RMName2} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Contact</label>
          <input type="text" className="form-control" value={clientCompanyData.RMContact2} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">RMO 3 Name</label>
          <input type="text" className="form-control" value={clientCompanyData.RMName3} disabled />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Contact</label>
          <input type="text" className="form-control" value={clientCompanyData.RMContact3} disabled />
        </div>
         <div className="col-lg-12">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Description</label>
            <textarea className="form-control h-100" rows="3" value={clientCompanyData.Description} disabled />
          </div>
        </div>
      </div>
    
    </>
  )
}

export default ViewClientCompany